import { inverterInformation } from "../../DataFiles/inverterInformation";
import "../Design&Structure/modulePreview.css";
import Patterns from "../summaryReport/subComponents/patterns";

const InverterPreview = (props) => {
  const { inverterDetail } = props;

  let inverterBrand = inverterInformation.find(
    (item) =>
      item.brand === inverterDetail.inverterManufacturer &&
      item.phase === inverterDetail.inverterPhase &&
      item.systemType === inverterDetail.systemType
  );
  let inverterInfo =
    inverterDetail.inverterType !== "Select"
      ? inverterBrand.inverterType.find(
          (item) => item.name === inverterDetail.inverterType
        )
      : [];

  return (
    <>
      <div id="panel-datasheet" className="panel-datasheet">
        {/* Patterns */}
        <Patterns />
        <main className="pd-body">
          <img
            className="img"
            src={inverterInfo.dataSheet1}
            alt="Inverter"
          ></img>
        </main>
      </div>
      <div id="panel-datasheet" className="panel-datasheet">
        {/* Patterns */}
        <Patterns />
        <main className="pd-body">
          <img
            className="img"
            src={inverterInfo.dataSheet2}
            alt="Inverter"
          ></img>
        </main>
      </div>
    </>
  );
};

export default InverterPreview;
